// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"340":"fa688ef6","1469":"fa688ef6","4581":"fa688ef6","6209":"46da4486","7881":"fa688ef6"}[chunkId] + ".chunk.css";
};